const RENDERER_STATUS = {
    IDLE: 'IDLE',
    RENDERING: 'RENDERING',
    DONE: 'DONE',
    ERROR: 'ERROR',
    CLEARED: 'CLEARED',
};

export default RENDERER_STATUS;
